// 系统路由
// 标准数据路由
export default {
  path: "/system",
  name: "system",
  meta: { title: "系统管理", icon: "system" },
  children: [
    {
      path: "/system/dict",
      name: "dict",
      component: () =>
        import(/* webpackChunkName: "dict" */ "@/views/system/dict"),
      meta: { title: "字典管理", icon: "dict" },
    },
    // 部门管理
    {
      path: "/system/mechanismManage",
      name: "mechanismManage",
      component: () =>
        import(
          /* webpackChunkName: "mechanismManage" */ "@/views/system/mechanismManage"
        ),
      meta: {
        title: "部门管理",
        icon: "mechanism",
      },
    },
    // 账号管理
    {
      path: "/system/accountManage",
      name: "accountManage",
      component: () =>
        import(
          /* webpackChunkName: "accountManage" */ "@/views/system/accountManage"
        ),
      meta: {
        title: "账号管理",
        icon: "personnel-manage",
      },
    },
    // 角色管理
    {
      path: "/system/roleManage",
      name: "roleManage",
      component: () =>
        import(
          /* webpackChunkName: "roleManage" */ "@/views/system/roleManage"
        ),
      meta: {
        title: "角色管理",
        icon: "role",
      },
    },
    // 许可管理
    {
      path: "/system/permissionManage",
      name: "permissionManage",
      component: () =>
        import(
          /* webpackChunkName: "permissionManage" */ "@/views/system/permissionManage"
        ),
      meta: {
        title: "许可管理",
        icon: "permission-manage",
      },
    },
    // 操作管理
    {
      path: "/system/operationManage",
      name: "operationManage",
      component: () =>
        import(
          /* webpackChunkName: "operationManage" */ "@/views/system/operationManage"
        ),
      meta: {
        title: "操作管理",
        icon: "operation",
      },
    },
  ],
};
